export const TRACKING_ID = `${
  import.meta.env.VITE_TRACKING_ID_GOOGLE_ANALYTICS
}`;
